import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';

import KDSCheckbox from '@decisiv/ui-components/lib/components/Checkbox';

const CheckboxList = ({ name, defaultValue, options, ...props }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const handleOnCheck = (currentValues, value) =>
    currentValues.includes(value)
      ? currentValues.filter((currVal) => currVal !== value)
      : [...currentValues, value];

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) =>
        options.map((option) => (
          <KDSCheckbox
            key={option.label}
            checked={value.includes(option.value)}
            label={option.label}
            value={option.value}
            onChange={({ target }) =>
              onChange(handleOnCheck(value, target.value))
            }
            warningMessage={errors[name]?.message?.toString()}
            {...props}
          />
        ))
      }
    />
  );
};

CheckboxList.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.shape({}),
      ]),
      label: PropTypes.string,
    }),
  ).isRequired,
};

CheckboxList.defaultProps = {
  defaultValue: [],
};

export default CheckboxList;
